module.exports = __webpack_public_path__ + "static/img/manual.88626bcd.png";